
import { defineComponent } from "vue";
import { useAppConfig } from "@/config";
import { useLayout, useGammaData, useOrgSettings } from "@/services";
import { mapState } from "pinia";

const { menuRight } = useAppConfig();

export default defineComponent({
  name: "RightSidebarMenu",
  data: () => ({
    selectedMenuItem: menuRight[0].name,
  }),
  computed: {
    ...mapState(useOrgSettings, ["showBookUploader"]),
    ...mapState(useLayout, ["isBottomDrawerOpen"]),
    menu() {
      return useGammaData().hasDataSources
        ? menuRight
        : menuRight.filter((menu) => menu.name !== "filters");
    },
    rsIndex: {
      get() {
        return useLayout().rightSidebarIndex;
      },
      set(val: any) {
        useLayout().rightSidebarIndex = val;
      },
    },
    isRsOpen: {
      get: () => {
        return useLayout().isRightSidebarOpen;
      },
      set(val: any) {
        useLayout().isRightSidebarOpen = val;
      },
    },
  },
  methods: {
    onSidebarClick(name: string) {
      const rightMenuIndex = menuRight.findIndex((item) => item.name === name);
      this.selectedMenuItem =
        menuRight.find((x) => x.name === name)?.name || "";
      if (this.rsIndex === rightMenuIndex) {
        this.isRsOpen = !this.isRsOpen;
      } else {
        this.rsIndex = rightMenuIndex;
        this.isRsOpen = true;
      }
    },
  },
});
